import { useEffect, useState } from "react";
import { adminHealth } from "../../lib/api";

export default function AdminHealthPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  async function refresh() {
    setLoading(true);
    try { setData(await adminHealth()); }
    finally { setLoading(false); }
  }
  useEffect(() => { refresh(); }, []);

  if (!data) {
    return <p className="text-sm text-white/45 font-serif-display italic">Loading…</p>;
  }

  return (
    <div data-testid="admin-health-page" className="space-y-8">
      <header>
        <h1 className="font-serif-display italic text-2xl md:text-3xl text-white/85">Health</h1>
        <p className="mt-1 text-sm text-white/50 font-serif-display italic">
          {data.totals.photographs} photographs · {data.totals.published} published · {data.totals.relationships} question routes
        </p>
      </header>

      <button type="button" onClick={refresh} className="btn-ghost" disabled={loading}>
        {loading ? "Refreshing…" : "Refresh"}
      </button>

      <Section title="Photographs with no incoming question (only reachable via random entry)" ids={data.no_incoming_edges} testid="health-no-incoming" />
      <Section title="Dead ends — photographs with no onward questions" ids={data.no_outgoing_edges} testid="health-no-outgoing" />

      <section>
        <h2 className="font-serif-display italic text-lg text-white/85">Broken routes</h2>
        {data.broken_relationships.length === 0 ? (
          <p className="mt-2 text-sm text-white/45 font-serif-display italic">None.</p>
        ) : (
          <ul className="mt-2 space-y-2 text-sm text-red-300/80 font-serif-display italic" data-testid="health-broken">
            {data.broken_relationships.map((b) => (
              <li key={b.id}>{b.source_id} → {b.destination_id}: {b.question}</li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}

function Section({ title, ids, testid }) {
  return (
    <section>
      <h2 className="font-serif-display italic text-lg text-white/85">{title}</h2>
      {ids.length === 0 ? (
        <p className="mt-2 text-sm text-white/45 font-serif-display italic">None.</p>
      ) : (
        <ul className="mt-2 flex flex-wrap gap-2" data-testid={testid}>
          {ids.map((id) => (
            <li key={id} className="text-xs font-mono-editor text-white/80 border border-white/15 rounded-full px-3 py-1">
              {id}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
